<template>
  <section class="py-12 px-4 border-y" style="background-color: var(--color-krate-blue-50); border-color: var(--color-krate-blue-100);">
    <div class="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
      <div>
        <div class="text-2xl md:text-3xl font-bold" style="color: var(--color-krate-blue-600);">
          Run <em>any</em> <code style="background: var(--color-krate-blue-100); padding: 2px 8px; border-radius: 4px; font-size: 0.8em; font-weight: 700;">devcontainer.json</code>
        </div>
      </div>
      <div>
        <div class="text-2xl md:text-3xl font-bold" style="color: var(--color-krate-blue-600);">Real VM sandboxing</div>
      </div>
      <div>
        <div class="text-2xl md:text-3xl font-bold" style="color: var(--color-krate-blue-600);">Policy as code</div>
      </div>
    </div>
  </section>
</template>
